import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import Prospects from "@/pages/Prospects";

export const Route = createFileRoute("/_app/prospects/")({
  head: () => ({ meta: [
    { title: "Prospects — Thiia" },
    { name: "description", content: "Vos prospects et leurs analyses dans Thiia." },
    { property: "og:title", content: "Prospects — Thiia" },
    { property: "og:description", content: "Vos prospects et leurs analyses dans Thiia." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="prospects">
      <Prospects />
    </ModuleGuard>
  );
}
